import { useState } from "react";
import apiService from "services/api";
import { useHistory } from "react-router-dom";
import { Input, Label, FormGroup } from "reactstrap";

import { useNotificationContext } from "contexts";
import { phoneNumberCountryCodes } from "./constants";

const NewParentPage = () => {
	const history = useHistory();

	const emptyChildForm = {
		firstName: "",
		lastName: "",
		hoursLeft: undefined,
		age: undefined,
		email: undefined,
	};

	const initialState = {
		firstName: "",
		lastName: "",
		phoneNumber: "",
		email: "",
		address: "",
		membershipType: "VIP",
		password: "",
		phoneNumberCountryCode: "+852",
		gender: "Male",
		numberOfChildren: "0",
	};

	const { createNotification } = useNotificationContext();
	const [newParentForm, setNewParentForm] = useState(initialState);
	const [showPassword, setShowPassword] = useState(false);
	const [childrenForm, setChildrenForm] = useState([]);

	const [newChildForm, setNewChildForm] = useState(emptyChildForm);

	const handleNewChildForm = (e) => {
		setNewChildForm((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleFormChange = (e) => {
		setNewParentForm((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const submitNewParentForm = (e) => {
		e.preventDefault();
		apiService.parent
			.create(newParentForm)
			.then(() => {
				createNotification({
					type: "success",
					message: "Successfully created a new member",
				});
				history.push("/parent");
			})
			.catch((error) =>
				createNotification({
					type: "danger",
					message: error.message,
				})
			);
	};

	const saveNewChild = () => {
		setChildrenForm((prevState) => [...prevState, newChildForm]);
	};

	const deleteNewChild = (indexToDelete) => {
		setChildrenForm((prevState) => prevState.filter((child, index) => index !== indexToDelete));
	};

	const resetFields = () => {
		setNewParentForm(initialState);
		setChildrenForm([]);
		setNewChildForm(emptyChildForm);
	};

	return (
		<form onSubmit={submitNewParentForm} className="content">
			<h5 className="text-center mb-4">Add New Member</h5>
			<div className="d-flex justify-content-center">
				<div className="w-75">
					<div className="input-group mb-3">
						<div className="input-group-prepend">
							<span className="input-group-text">Name</span>
						</div>
						<input
							type="text"
							className="form-control"
							name="firstName"
							value={newParentForm.firstName}
							onChange={handleFormChange}
							placeholder="First Name"
							required
						/>
						<input
							type="text"
							className="form-control"
							name="lastName"
							placeholder="Last Name"
							value={newParentForm.lastName}
							onChange={handleFormChange}
							required
						/>
					</div>
					<div className="input-group mb-3">
						<div className="input-group-prepend">
							<span className="input-group-text">Email</span>
						</div>
						<input
							type="email"
							className="form-control"
							placeholder="Member's Email"
							value={newParentForm.email}
							onChange={handleFormChange}
							name="email"
						/>
					</div>
					<div className="d-flex">
						<div className="input-group mb-3 mr-3">
							<div className="input-group-prepend">
								<span className="input-group-text">Password</span>
							</div>
							<input
								type={!showPassword ? "password" : "text"}
								className="form-control"
								placeholder="Account Password"
								value={newParentForm.password}
								onChange={handleFormChange}
								name="password"
								required
							/>
						</div>
						<FormGroup check>
							<Label className="form-check-label">
								<Input
									className="form-check-input"
									type="checkbox"
									onChange={() => setShowPassword((prevState) => !prevState)}
									value={showPassword}
								/>
								Show
								<span className="form-check-sign">
									<span className="check"></span>
								</span>
							</Label>
						</FormGroup>
					</div>
					<div className="input-group mb-3">
						<div className="input-group-prepend">
							<span className="input-group-text">Phone Number</span>
						</div>
						<select
							className="form-control"
							value={newParentForm.phoneNumberCountryCode}
							onChange={(e) =>
								setNewParentForm((prevState) => ({
									...prevState,
									phoneNumberCountryCode: e.target.value,
								}))
							}
							placeholder="Country Code"
						>
							{phoneNumberCountryCodes.map((phoneNumberCountryCode, index) => (
								<option
									value={phoneNumberCountryCode.code}
									key={index}
								>{`${phoneNumberCountryCode.country} (${phoneNumberCountryCode.code})`}</option>
							))}
						</select>

						<input
							type="text"
							className="form-control"
							placeholder="Member's Phone Number"
							name="phoneNumber"
							required
							maxLength="8"
							value={newParentForm.phoneNumber}
							onChange={handleFormChange}
						/>
					</div>
					{/* Newly Added */}
					<div className="row mb-1">
						<div className="col">
							<div className="input-group">
								<div className="input-group-prepend">
									<label className="input-group-text pr-2" htmlFor="gender">
										Gender
									</label>
								</div>
								<select
									className="form-control custom-select"
									id="gender"
									name="gender"
									placeholder="Choose..."
									onChange={handleFormChange}
									value={newParentForm.gender}
									required
								>
									<option value="Male">Male</option>
									<option value="Female">Female</option>
									<option value="Prefer not to say">Prefer not to say</option>
								</select>
							</div>
						</div>
						<div className="col">
							<div className="input-group">
								<div className="input-group-prepend">
									<label className="input-group-text pr-2" htmlFor="numberOfChildren">
										Number Of Children
									</label>
								</div>
								{/* Need to put validation to prevent negative numbers or decimal values being submitted */}
								<input
									type="number"
									className="form-control"
									placeholder="Number of Children"
									name="numberOfChildren"
									min="0"
									step="1"
									defaultValue="0"
									value={newParentForm.numberOfChildren}
									onChange={handleFormChange}
								/>
							</div>
						</div>
					</div>

					<div className="input-group mb-3">
						<div className="input-group-prepend">
							<span className="input-group-text">Address</span>
						</div>
						<input type="text" className="form-control" name="address" value={newParentForm.address} onChange={handleFormChange} />
					</div>
					<div className="input-group mb-3">
						<div className="input-group-prepend">
							<label className="input-group-text pr-2" htmlFor="membershipType">
								Membership Type
							</label>
						</div>
						<select
							className="form-control custom-select"
							id="membershipType"
							placeholder="Choose..."
							name="membershipType"
							onChange={handleFormChange}
							required
						>
							<option value="VIP">VIP</option>
							{/* I changed the value and label. I don't know if will affect DB or not.*/}
							<option value="Group">Group</option>
							<option value="Coffee">Coffee</option>
							<option value="Staff">Staff</option>
							<option value="Guest">Guest</option>
						</select>
					</div>
				</div>
			</div>

			<div className="d-flex justify-content-center">
				<div className="w-75">
					<div className="d-flex justify-content-end mt-5">
						<button className="btn btn-success mx-1" type="submit">
							Submit
						</button>
						<button className="btn btn-secondary" type="button" onClick={resetFields}>
							Reset
						</button>
					</div>
				</div>
			</div>
		</form>
	);
};

export default NewParentPage;
